@use "app/styles/colors" as colors;

.section {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
  gap: 1.5rem;
  width: 100%;
  margin: 2.5rem 0;
  @media (min-width: 64rem) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.trusted,
.familiar,
.performant,
.scalable {
  --widget-size: min(10rem, max(6rem, 21dvw));
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover::before {
    animation: bounce 0.8s;
    @keyframes bounce {
      0% {
        transform: translateY(0);
      }
      10% {
        transform: translateY(0) scale(1.1, 0.9);
      }
      30% {
        transform: translateY(-20px) scale(0.95, 1.05);
      }
      40% {
        transform: translateY(0) scale(1.05, 0.95);
      }
      50% {
        transform: translateY(-10px) scale(0.98, 1.02);
      }
      70% {
        transform: translateY(0) scale(1.02, 0.98);
      }
      100% {
        transform: translateY(0);
      }
    }
  }
  &::before {
    content: "";
    display: block;
    background-repeat: no-repeat;
    height: var(--widget-size);
    width: var(--widget-size);
  }

  h3 {
    font-size: 2rem;
    font-weight: 400;
    margin: 0.5rem 0;
    font-size: max(1.5rem, min(2rem, 7dvw));
  }

  p {
    text-wrap: balance;
    font-size: max(0.75rem, min(1rem, 3.5dvw));
    max-width: 28ch;
    @media (min-width: 64rem) {
      text-wrap: pretty;
    }
  }
}

.trusted {
  @include colors.section("blue");
}

.familiar {
  @include colors.section("red");
}

.performant {
  @include colors.section("yellow");
}

.scalable {
  @include colors.section("green");
}

.trusted::before {
  rotate: -5deg;
  background-position: top center;
  background-image: url("/assets/widget/doc.svg");
}

.familiar::before {
  rotate: 5deg;
  background-position: top 12px center;
  background-image: url("/assets/widget/cookie.svg");
}

.performant::before {
  rotate: -5deg;
  scale: -1 1;
  background-position: top 14px center;
  background-image: url("/assets/widget/link.svg");
}

.scalable::before {
  rotate: 5deg;
  background-position: top center;
  background-image: url("/assets/widget/pixel.svg");
}

@media (prefers-color-scheme: dark) {
  .trusted::before {
    background-image: url("/assets/widget/doc.svg#dark");
  }

  .familiar::before {
    background-image: url("/assets/widget/cookie.svg#dark");
  }

  .performant::before {
    background-image: url("/assets/widget/link.svg#dark");
  }

  .scalable::before {
    background-image: url("/assets/widget/pixel.svg#dark");
  }
}

@media (min-width: 48rem) {
  .familiar::before,
  .performant::before,
  .scalable::before {
    background-position: top center;
  }
}
